<div class="body-card pt-3">
  <p-table
    [value]="stocks"
    [paginator]="true"
    class="custom-table"
    [lazy]="true"
    (onLazyLoad)="onLazyLoad($event)"
    [rows]="pageSize"
    [totalRecords]="totalCount"
    [loading]="loading"
  >
    <ng-template pTemplate="header">
      <tr>
        <th>
          <div class="flex justify-content-center">
            {{'UserPalletStock.NameColumn' | translate}}
          </div>
        </th>
        <th>
          <div class="flex justify-content-center">
            {{'UserPalletStock.FridgeStorageColumn' | translate}}
          </div>
        </th>
        <th>
          <div class="flex justify-content-center">
            {{'UserPalletStock.ActionsColumn' | translate}}
          </div>
        </th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-stock>
      <tr>
        <td>
          <div class="flex justify-content-center">
            {{stock.name}}
          </div>
        </td>
        <td>
          <div class="flex justify-content-center">
            {{stock.fridgeStorage?.name ?? '-'}}
          </div>
        </td>
        <td>
          <div class="flex justify-content-center gap-3">
            <p-button
              icon="pi pi-eye"
              pTooltip="{{'UserPalletStock.ViewStock' | translate}}"
              tooltipPosition="bottom"
              class="custom-button-icon green-btn"
              (click)="onViewStock(stock)">
            </p-button>
            <p-button
              icon="pi pi-sliders-h"
              pTooltip="{{'UserPalletStock.StockColumnRuleConfigText' | translate}}"
              tooltipPosition="bottom"
              class="custom-button-icon green-btn"
              (click)="onViewRules(stock)">
            </p-button>
            <p-button
              [disabled]="stock.alertNumber == 0"
              icon="pi pi-exclamation-triangle"
              pTooltip="{{'UserPalletStock.ViewStockAlert' | translate}}"
              tooltipPosition="bottom"
              class="custom-button-icon yellow-btn"
              (click)="onShowStockAlert(stock.id)">
            </p-button>
            <p-button
              icon="pi pi-cog"
              pTooltip="Configurar variedad real"
              tooltipPosition="bottom"
              class="custom-button-icon blue-btn"
              (click)="onShowQuarterConfig(stock)">
            </p-button>
            <p-button
              icon="pi pi-plus"
              pTooltip="{{'UserPalletStock.CreateProgramFromStock' | translate}}"
              tooltipPosition="bottom"
              class="custom-button-icon blue-btn"
              (click)="onShowProgramFromStock(stock)">
            </p-button>
            <p-menu #menuEdit [model]="stock.menu" [popup]="true" appendTo="body"/>
            <p-button
              icon="pi pi-ellipsis-v"
              pTooltip="{{'UserPalletStock.ViewStockStats' | translate}}"
              tooltipPosition="bottom"
              class="custom-button-icon green-btn"
              (click)="menuEdit.toggle($event)">
            </p-button>
          </div>
        </td>
      </tr>
    </ng-template>
  </p-table>
</div>
